import { render, staticRenderFns } from "./BayNoteModal.vue?vue&type=template&id=3b1c2b6e&scoped=true"
import script from "./BayNoteModal.vue?vue&type=script&lang=js"
export * from "./BayNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c2b6e",
  null
  
)

export default component.exports